// ─────────────────────────────────────────────────────────────────────────────
// Ranking dos combos de busca.
//
// As listas do MySuite são grandes: passam de 400 classificações. Um `<select>`
// nativo obriga a rolar até achar; um filtro por "contém" devolve na frente
// itens que só têm a palavra no meio do nome.
//
// A pontuação resolve isso pondo o mais provável no topo:
//
//   nome exato                 1000
//   começa com o que foi digitado 500
//   contém em qualquer lugar      200
//   todas as palavras presentes   100   (na ordem que for)
//
// Os números não são calibráveis: são degraus, e a distância entre eles existe
// para que uma categoria nunca empate com a outra.
//
// Módulo puro — testado em scripts/teste-combo.mjs.
// ─────────────────────────────────────────────────────────────────────────────

export const MAX_RESULTADOS = 50;

/** Sem acento, sem caixa, sem espaço sobrando — para comparar como gente lê. */
export function normalizar(texto) {
  return String(texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

/** Quanto este item combina com a busca. 0 = não combina. */
export function pontuar(nome, busca) {
  const n = normalizar(nome);
  const q = normalizar(busca);
  if (!q) return 1;              // sem busca, tudo aparece na ordem original
  if (!n) return 0;

  if (n === q) return 1000;
  if (n.startsWith(q)) return 500;
  if (n.includes(q)) return 200;

  // Última chance: todas as palavras da busca aparecem, em qualquer ordem.
  // "nf emissao" acha "Erro na emissão de NF-e".
  const palavras = q.split(/\s+/).filter(Boolean);
  if (palavras.length > 1 && palavras.every(p => n.includes(p))) return 100;

  return 0;
}

/**
 * Filtra e ordena a lista.
 * @param {Array} itens  [{ codigo, nome }]
 * @param {string} busca
 */
export function filtrarPorBusca(itens = [], busca = '') {
  return itens
    .map(item => ({ item, ponto: pontuar(item.nome, busca) }))
    .filter(r => r.ponto > 0)
    // Empate resolvido por nome, para a lista não dançar entre digitações.
    .sort((a, b) => b.ponto - a.ponto || String(a.item.nome).localeCompare(String(b.item.nome), 'pt-BR'))
    .slice(0, MAX_RESULTADOS)
    .map(r => r.item);
}

/**
 * O item cujo nome casa EXATAMENTE com o texto.
 *
 * É o que valida o código escondido do combo: enquanto o texto digitado não
 * casar com um item de verdade, o código fica inválido — senão o operador
 * editaria o texto e o ticket sairia com o código do item anterior.
 */
export function itemExato(itens = [], texto = '') {
  const t = normalizar(texto);
  if (!t) return null;
  return itens.find(i => normalizar(i.nome) === t) || null;
}
